// extracted by mini-css-extract-plugin
export default {"facets":"PracticeFacets_facets__N+2F3"};